import React, { useCallback, useMemo } from 'react'
import { generatePath } from 'react-router'
import PropTypes from 'prop-types'

import { MODULES } from 'portal/lib/constants'
import { TextLink } from 'portal/lib/primitives'
import { useModuleIds } from 'portal/lib/hooks'

import * as ROUTES from 'portal/routes'

import { useMixpanelEvents } from './mixpanel'

export function NavigateButton({ item }) {
  const { accountId } = useModuleIds()

  const { trackEventClick } = useMixpanelEvents()
  const onClick = useCallback(() => {
    trackEventClick(item.sourceId, item.sourceType)
  }, [item, trackEventClick])

  const getRecordLinkUri = (params, moduleName, recordId) => {
    let route = MODULES.select(moduleName, {
      waste: ROUTES.WASTE_RECORD_DETAILS,
      delivery: ROUTES.DELIVERY_RECORD_DETAILS
    })

    return generatePath(route, {
      ...params,
      recordId: recordId
    })
  }

  const uri = useMemo(() => {
    return getRecordLinkUri(
      {
        accountId: accountId,
        projectId: item.projectId,
        moduleName: item.moduleName
      },
      item.moduleName,
      item.recordId
    )
  }, [accountId, item.moduleName, item.projectId, item.recordId])

  return (
    <TextLink onClick={onClick} to={uri}>
      {item.destinationDisplayName || 'View'}
    </TextLink>
  )
}

NavigateButton.propTypes = {
  item: PropTypes.shape({
    destinationAddress: PropTypes.string.isRequired,
    destinationDisplayName: PropTypes.string,
    sourceId: PropTypes.string.isRequired,
    sourceType: PropTypes.string.isRequired
  }).isRequired
}
